import useAPI from '@/hooks/useAPI';
import SchedulingLinksRepository from '@/repositories/SchedulingLinksRepository';
import { SchedulingLinksParams } from '@/types/schedulingLink';

const useSchedulingLinks = ({
  personId,
  params,
  enabled = true
}: {
  personId: string;
  params: SchedulingLinksParams;
  enabled?: boolean;
}) => {
  const schedulingLinksRepository = SchedulingLinksRepository();

  return useAPI({
    queryKey: ['getSchedulingLinks', params],
    queryFn: async () => {
      return await schedulingLinksRepository.getSchedulingLinks(personId, params);
    },
    enabled
  });
};

export default useSchedulingLinks;
